import { render, staticRenderFns } from "./ModalPage.vue?vue&type=template&id=f7a5caa8"
import script from "./ModalPage.vue?vue&type=script&lang=js"
export * from "./ModalPage.vue?vue&type=script&lang=js"
import style0 from "./ModalPage.vue?vue&type=style&index=0&id=f7a5caa8&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports